<div class="details-top-bar d-flex justify-content-between">
  <div class="d-flex overflow-hidden align-items-center">
    @if (showArrows()) {
      <span (click)="scrollLeft()">
        <mat-icon [ngClass]="{ disabled: isLeftArrowDisabled() }">chevron_left</mat-icon>
      </span>
    }
    <div class="scroll-content" #scrollContainer>
      @if (collar()) {
        <ng-container [ngTemplateOutlet]="collarTitle"></ng-container>
      }
      @if (trap()) {
        <ng-container [ngTemplateOutlet]="trapTitle"></ng-container>
      }
      @if (connectedDevice()) {
        <ng-container [ngTemplateOutlet]="connectedCollarTitle"></ng-container>
      }
    </div>
    @if (showArrows()) {
      <span (click)="scrollRight()">
        <mat-icon [ngClass]="{ disabled: isRightArrowDisabled() }"> chevron_right</mat-icon>
      </span>
    }
  </div>
  <div class="d-flex">
    @if (isSmall()) {
      @if (collar()) {
        <button
          mat-icon-button
          (click)="onClick(Item.COLLAR, collar().idDevice)"
          [matTooltip]="isDesktop ? 'Show details' : 'Open in new tab'"
          color="primary"
        >
          <mat-icon>open_in_new</mat-icon>
        </button>
      }
      @if (trap()) {
        <button
          mat-icon-button
          (click)="onClick(Item.TRAP, trap().idDevice)"
          [matTooltip]="isDesktop ? 'Show details' : 'Open in new tab'"
          color="primary"
        >
          <mat-icon>open_in_new</mat-icon>
        </button>
      }
    }

    @if (connectedDevice()?.deviceTime) {
      <button
        mat-icon-button
        (click)="onReloadDevice()"
        matTooltip="Reload device"
        [disabled]="isConnectedDeviceBtnDisabled || isReloading()"
      >
        @if (isReloading()) {
          <mat-spinner color="accent" [diameter]="24"></mat-spinner>
        } @else {
          <mat-icon color="accent">refresh</mat-icon>
        }
      </button>
    }

    @if (showClose()) {
      <button mat-icon-button (click)="onClickClose()" matTooltip="Close">
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>
</div>
<!-- #collarTitle -->
<ng-template #collarTitle>
  <div class="d-flex flex-column py-6 px-12 wrap-now">
    <h2 class="item-id pt-6">ID: {{ collar().idDevice }}</h2>
    <div class="item-name d-flex">
      <div class="pb-6">
        {{ concatString(collar().name) }}
      </div>
    </div>
  </div>

  @if (collar().lastPosition?.latitude && collar().lastPosition?.longitude) {
    <vectronic-details-top-bar-item
      header="Recent Position LAT/LON"
      [value]="roundPosition(collar().lastPosition)"
      [extraInfo]="
        collar().lastPosition?.acquisitionTime.replace('Z', '') | date: 'yyyy-MM-dd HH:mm:ss'
      "
    ></vectronic-details-top-bar-item>
  }
  @if (collar().distanceLastPosition) {
    <vectronic-details-top-bar-item
      header="Distance"
      tooltip="Distance to last position"
      [value]="getRoundNumber(collar().distanceLastPosition) + ' m'"
    ></vectronic-details-top-bar-item>
  }
  @if (translateMortalityStatusShort(collar().lastPosition?.mortalityStatus)) {
    <vectronic-details-top-bar-item
      header="Status"
      [value]="translateMortalityStatusShort(collar().lastPosition?.mortalityStatus)"
      matTooltip="Mortality Status of the recent position"
    ></vectronic-details-top-bar-item>
  }
</ng-template>
<!-- #trapTitle -->
<ng-template #trapTitle>
  <div class="d-flex flex-column py-6 px-12 wrap-now">
    <h2 class="item-id pt-6">ID: {{ trap().idDevice }}</h2>
    <div class="item-name d-flex pb-6">
      {{ concatString(trap().name) }}
    </div>
  </div>
</ng-template>
<!-- #connectedCollarTitle -->
<ng-template #connectedCollarTitle>
  <vectronic-details-top-bar-item
    header="ID"
    [isBold]="true"
    [value]="connectedDevice()?.deviceId"
  ></vectronic-details-top-bar-item>

  <div class="d-flex flex-column py-6 px-12 wrap-now" style="min-width: 185px">
    <div class="item-name pt-6">Device Time (UTC)</div>
    <div class="d-flex pb-6">
      {{ time | async | date: 'yyyy-MM-dd HH:mm:ss' : 'UTC' }}
    </div>
  </div>

  <vectronic-details-top-bar-item
    header="Device State"
    [value]="connectedDevice()?.deviceState"
  ></vectronic-details-top-bar-item>

  <div class="d-flex flex-column py-6 px-12 wrap-now" style="min-width: 185px">
    <div class="item-name pt-6">Firmware</div>
    <div class="d-flex pb-6">
      <span class="pr-6">
        {{ connectedDevice()?.firmwareVersion.version.major }}.{{
          connectedDevice()?.firmwareVersion.version.minor
        }}.{{ connectedDevice()?.firmwareVersion.version.release }}</span
      >
      @if (hasNewerFirmware(connectedDevice())) {
        @if (connectedDevice().write) {
          <mat-icon
            color="accent"
            class="upgrade-icon"
            (click)="firmwareUpdate.emit()"
            [matTooltip]="
              isFirmwareUpdateAvailable() ? 'Firmware update available' : 'Firmware is up to date'
            "
          >
            arrow_circle_up
          </mat-icon>
        } @else {
          <mat-icon
            class="disabled upgrade-icon"
            matTooltip="You do not have permission to update firmware"
            >arrow_circle_up
          </mat-icon>
        }
      }
    </div>
  </div>
</ng-template>
